import Button from 'src/autobahn/components/button/button';
import styles from './form-layout.module.scss';
import classNames from 'classnames';
import useStore from 'src/hooks/use-store';
import Form from 'src/autobahn/components/form';
import {useFormRef} from 'src/autobahn/hooks/useFormRef';
import {useIntl} from 'react-intl';

interface FormLayoutProps {
  className?: string;
  children: React.ReactElement | React.ReactElement[];
  title?: string;
  onCancel: () => void;
  onSubmit: React.FormEventHandler<HTMLFormElement>;
}

const FormLayout = ({
  children,
  className,
  title,
  onCancel,
  onSubmit,
}: FormLayoutProps) => {
  const {store} = useStore();
  const {theme} = store;
  const intl = useIntl();

  const {formRef, submit} = useFormRef();

  return (
    <div className={classNames(styles.container, className)}>
      <div className={styles.formContainer}>
        {!!title && <h3 className={styles.header} style={{color: theme}}>{title}</h3>}
        <Form ref={formRef} onSubmit={onSubmit}>
          {children}
        </Form>
      </div>

      <div className={styles.actionsContainer}>
        <Button variant='secondary' onClick={onCancel}>
          <span>{intl.formatMessage({id: 'sharedCancel'})}</span>
        </Button>
        <Button onClick={submit}>
          <span>{intl.formatMessage({id: 'sharedSave'})}</span>
        </Button>
      </div>
    </div>
  );
};

export default FormLayout;
